import { render } from "./UiListSearch.vue?vue&type=template&id=64d58cca&ts=true"
import script from "./UiListSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiListSearch.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiListSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64d58cca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64d58cca', __exports__)) {
    api.reload('64d58cca', __exports__)
  }
  
  module.hot.accept("./UiListSearch.vue?vue&type=template&id=64d58cca&ts=true", () => {
    api.rerender('64d58cca', render)
  })

}


export default __exports__